import React, { useReducer } from 'react';
import {
  TextField,
  Select,
  MenuItem,
  Button
} from '@mui/material';
import { Box } from '@mui/system';
import { Chip } from '@mui/material'; // Added for Chip
import { InputAdornment } from '@mui/material'; // Import InputAdornment
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

const reducer = (state, action) => {
    switch (action.type) {
      case "tags":
        return { ...state, tags: action.value }
      case "attendance":
        return { ...state, attendance: action.value }
      case "attendanceOperator":
        return { ...state, attendanceOperator: action.value }
      case "minPrice":
        return { ...state, minPrice: action.value }
      case "maxPrice":
        return { ...state, maxPrice: action.value }
      case "sort":
        return { ...state, sort: action.value }
      case "sortDirection":
        return { ...state, sortDirection: action.value }
    }
    return state
  }

const FilterBar = ({
    currentFilters,
    setCurrentFilters,
    availableTags,
    openModal,
    fetchItems
  }) => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'));

    const [filterState, dispatch] = useReducer(reducer, currentFilters)

    const handleFilterChange = (type, value) => { // Changed value type to any
      dispatch({ type, value: value });
    };
  
    const handleSortChange = (value) => {
      dispatch({ type: 'sort', value: value });
      dispatch({ type: 'sortDirection', value: 'asc' }); // Reset direction
    };
  
    const handleSortDirectionChange = () => {
      dispatch({
        type: 'sortDirection',
        value: filterState?.sortDirection === 'asc' ? 'desc' : 'asc',
      });
    };

    return (
      <Box display="flex" flexWrap="wrap" gap={3} mb={4} alignItems="flex-end" flexDirection={isXs ? 'column' : 'row'}>
        <Box>
          <div>
            Filter by Tags
          </ div>
          <Select
            labelId="tag-filter-label"
            multiple
            value={filterState?.tags}
            onChange={(e) => handleFilterChange('tags', e.target.value)}
            renderValue={(selected) => (
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {selected.map((value) => (
                  <Chip key={value} label={value} />
                ))}
              </Box>
            )}
            sx={{ minWidth: isXs ? '100%' : 'auto' }}
          >
            {availableTags.map((tag) => (
              <MenuItem key={tag} value={tag}>
                {tag}
              </MenuItem>
            ))}
          </Select>
        </Box>
  
        {/* <Box>
          <label htmlFor="attendance-operator" className="block text-sm font-medium text-gray-700">
            Attendance Operator
          </label>
          <Select
            value={filterState.attendanceOperator}
            onChange={(e) => handleFilterChange('attendanceOperator', e.target.value)}
            sx={{ minWidth: isXs ? '100%' : 'auto' }}
          >
            <MenuItem value="gt">Greater Than</MenuItem>
            <MenuItem value="lt">Less Than</MenuItem>
            <MenuItem value="eq">Equal To</MenuItem>
          </Select>
        </Box> */}
  
        {/* <Box>
          <label htmlFor="attendance-filter" className="block text-sm font-medium text-gray-700">
            Filter by Attendance
          </label>
          <TextField
            id="attendance-filter"
            type="number"
            placeholder="Enter attendance..."
            value={filterState.attendance}
            onChange={(e) => handleFilterChange('attendance', e.target.value)}
            className="mt-1"
            sx={{ width: isXs ? '100%' : 'auto' }}
          />
        </Box> */}
  
        <Box>
          <label htmlFor="min-price-filter" className="block text-sm font-medium text-gray-700">
            Min Price
          </label>
          <TextField
            id="min-price-filter"
            type="number"
            placeholder="Enter min price..."
            value={filterState.minPrice}
            onChange={(e) => handleFilterChange('minPrice', e.target.value)}
            className="mt-1"
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
            sx={{ width: isXs ? '100%' : 'auto' }}
          />
        </Box>
  
        <Box>
          <label htmlFor="max-price-filter" className="block text-sm font-medium text-gray-700">
            Max Price
          </label>
          <TextField
            id="max-price-filter"
            type="number"
            placeholder="Enter max price..."
            value={filterState.maxPrice}
            onChange={(e) => handleFilterChange('maxPrice', e.target.value)}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
            className="mt-1"
            sx={{ width: isXs ? '100%' : 'auto' }}
          />
        </Box>
  
        <Box>
          <label htmlFor="sort-select" className="block text-sm font-medium text-gray-700">Sort by</label>
          <Select
            onChange={(e) => handleSortChange(e.target.value)}
            value={filterState.sort}
            sx={{ minWidth: isXs ? '100%' : 'auto' }}
          >
            <MenuItem value="">None</MenuItem>
            <MenuItem value="last_visited">Last Visit Date</MenuItem>
            <MenuItem value="price">Price</MenuItem>
          </Select>
          {filterState.sort === 'price' && (
            <Button
              variant="outlined"
              size="small"
              onClick={handleSortDirectionChange}
              className="mt-2"
            >
              {filterState.sortDirection === 'asc' ? 'Ascending' : 'Descending'}
            </Button>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: 2, flexDirection: isXs ? 'column' : 'row', width: isXs ? '100%' : 'auto' }}>
          <Button variant="contained"
                  onClick={() => {
                        setCurrentFilters(filterState)
                        fetchItems(
                            filterState.tags,
                            filterState.attendance,
                            filterState.attendanceOperator,
                            filterState.sort,
                            filterState.minPrice,
                            filterState.maxPrice,
                            filterState.sortDirection
                        );
                    }}
          sx={{ width: isXs ? '100%' : 'auto' }}>
            Apply Filters
          </Button>
          <Button variant="contained" onClick={openModal} sx={{ width: isXs ? '100%' : 'auto' }}>
            Add Item
          </Button>
        </Box>
      </Box>
    );
  };
  

// const FilterBar = (props) => {
//     const filters = props.filters
//     const setFilters = props.setFilters
//     const sort = props.sort
//     const setSort = props.setSort
//     const sortDirection = props.sortDirection
//     const setSortDirection = props.setSortDirection
//     const availableTags = props.availableTags
//     const applyFiltersAndSort = props.applyFiltersAndSort
//     const openModal = props.openModal

//     const handleFilterChange = (filterName, value) => {
//         setFilters(prevFilters => ({ ...prevFilters, [filterName]: value }));
//     };
//     const handleSortChange = (value) => {
//         setSort(value);
//         // Reset to ascending when sort field changes
//         setSortDirection('asc');
//     };
//     const handleSortDirectionChange = () => {
//         setSortDirection((prev) => (prev === 'asc' ? 'desc' : 'asc'));
//     };

//     return (
//         <div>
//             <Box display="flex" flexWrap="wrap" gap={3} mb={4} alignItems="flex-end">
//                 <Box>
//                     <label htmlFor="tag-filter" className="block text-sm font-medium text-gray-700">
//                         Filter by Tag
//                     </label>
//                     <Select
//                     labelId="tag-filter-label"
//                     multiple // Enable multiple selection
//                     value={filters.tags}
//                     onChange={(e) => handleFilterChange('tags', e.target.value)} // Type assertion
//                     renderValue={(selected) => ( // Custom rendering for selected chips
//                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                         {selected?.map((value) => (
//                             <Chip key={value} label={value} />
//                         ))}
//                         </Box>
//                     )}
//                     >
//                     {availableTags?.map((tag) => (
//                         <MenuItem key={tag} value={tag}>
//                         {tag}
//                         </MenuItem>
//                     ))}
//                     </Select>
//                 </Box>

//                 <Box>
//                     <label htmlFor="attendance-operator" className="block text-sm font-medium text-gray-700">
//                     Attendance Operator
//                     </label>
//                     <Select
//                     value={filters.attendanceOperator}
//                     onChange={(e) => handleFilterChange('attendanceOperator', e.target.value)}
//                     >
//                     <MenuItem value="gt">Greater Than</MenuItem>
//                     <MenuItem value="lt">Less Than</MenuItem>
//                     <MenuItem value="eq">Equal To</MenuItem>
//                     </Select>
//                 </Box>

//                 <Box>
//                     <label htmlFor="attendance-filter" className="block text-sm font-medium text-gray-700">
//                     Filter by Attendance
//                     </label>
//                     <TextField
//                     id="attendance-filter"
//                     type="number"
//                     placeholder="Enter attendance..."
//                     value={filters.attendance}
//                     onChange={(e) => handleFilterChange('attendance', e.target.value)}
//                     className="mt-1"
//                     />
//                 </Box>

//                 <Box>
//                     <label htmlFor="min-price-filter" className="block text-sm font-medium text-gray-700">
//                     Min Price
//                     </label>
//                     <TextField
//                     id="min-price-filter"
//                     type="number"
//                     placeholder="Enter min price..."
//                     value={filters.minPrice}
//                     onChange={(e) => handleFilterChange('minPrice', e.target.value)}
//                     className="mt-1"
//                     InputProps={{
//                         startAdornment: <InputAdornment position="start">$</InputAdornment>, // Add dollar sign
//                     }}
//                     />
//                 </Box>

//                 <Box>
//                     <label htmlFor="max-price-filter" className="block text-sm font-medium text-gray-700">
//                     Max Price
//                     </label>
//                     <TextField
//                     id="max-price-filter"
//                     type="number"
//                     placeholder="Enter max price..."
//                     value={filters.maxPrice}
//                     onChange={(e) => handleFilterChange('maxPrice', e.target.value)}
//                     InputProps={{
//                         startAdornment: <InputAdornment position="start">$</InputAdornment>, // Add dollar sign
//                     }}
//                     className="mt-1"
//                     />
//                 </Box>

//                 <Box>
//                     <label htmlFor="sort-select" className="block text-sm font-medium text-gray-700">Sort by</label>
//                     <Select onChange={(e) => handleSortChange(e.target.value)} value={sort}>
//                     <MenuItem value="">None</MenuItem>
//                     <MenuItem value="last_visited">Last Visit Date</MenuItem>
//                     <MenuItem value="price">Price</MenuItem>
//                     </Select>
//                     {sort === 'price' && (
//                     <Button
//                         variant="outlined"
//                         size="small"
//                         onClick={handleSortDirectionChange}
//                         className="mt-2"
//                     >
//                         {sortDirection === 'asc' ? 'Ascending' : 'Descending'}
//                     </Button>
//                     )}
//                 </Box>
//                 <Button variant="contained" onClick={applyFiltersAndSort}>
//                     Apply Filters
//                 </Button>
//                 <Button variant="contained" onClick={openModal}>
//                     Add Item
//                 </Button> {/* Button to open modal */}
//             </Box>
//         </div>
//     )
// }

export default FilterBar